import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ScaleIcon, HammerIcon, CircleDollarSignIcon } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    icon: <ScaleIcon className="w-8 h-8 text-copper" data-id="element-13" />,
    title: 'Lawyers',
    description: 'They want a $5,000 retainer just to "start probate," which doesn\'t actually stop the pipes from bursting or the mortgage from defaulting.'
  }, {
    icon: <HammerIcon className="w-8 h-8 text-copper" data-id="element-14" />,
    title: 'General Real Estate Advice',
    description: 'Tells you to "fix it up for top dollar," but you don\'t have the liquid cash or the time to manage a renovation from three states away.'
  }, {
    icon: <CircleDollarSignIcon className="w-8 h-8 text-copper" data-id="element-15" />,
    title: 'Random Investors',
    description: 'Circling like vultures, offering you 50 cents on the dollar because they can sense your desperation to "just be done with it."'
  }];
  return <section className="bg-cream py-24 px-4" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <FadeIn className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-19">
            Why What You've Tried Hasn't Worked
          </h2>
          <p className="text-lg text-text-dark/70 font-body max-w-2xl mx-auto" data-id="element-20">
            The traditional advice wasn't built for the urgency of an inherited
            property facing default.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-21">
          {approaches.map((approach, index) => <FadeIn key={index} delay={0.2 + index * 0.1} className="bg-white p-8 border border-cream-dark shadow-editorial relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-22">
              <div className="absolute top-0 left-0 w-full h-1 bg-copper transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-23" />
              <div className="mb-6 bg-cream inline-block p-4 rounded-full" data-id="element-24">
                {approach.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-navy mb-4" data-id="element-25">
                {approach.title}
              </h3>
              <p className="text-text-dark/80 font-body leading-relaxed" data-id="element-26">
                {approach.description}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}